import React, {useContext} from "react";
import {AuthContext} from "../../../context/AuthContext";
import TopProducts from "../../../components/Dashboard/TopProducts/TopProducts";
import ChartBlock from "../../../components/Dashboard/Charts/ChartBlock";

const DashboardPage = () => {
    const user = useContext(AuthContext);

    if (!user) return null;

    return (
        <div className="sl-container sl-m-auto sl-my-8 sl-h-full sl-mb-21">
            <div className={"flex flex-col sl-gap-10 "}>
            <span
                className={"sl-text-left sl-text-gray-900 sl-text-xxl sl-font-semibold"}>Welcome back, {user.first_name}</span>
                <TopProducts/>

                <ChartBlock
                    seriesLabels={['Your impressions', 'Essentials']}
                    tooltipText={'Number if times your account was viewed in a search.'}
                    title={"Broker Impressions"} subTitle={"Brokers that saw you most in searches"}
                    apiRoute={'broker-impressions'} blockTypeTitle={'impressions'}/>

                <ChartBlock
                    seriesLabels={['Your profile views', 'Essentials']}
                    tooltipText={"Number of times a user clicked to view your extended profile."}
                    title={"Profile Views"} subTitle={"Brokers that viewed your profile most"}
                    apiRoute={'profile-views'} blockTypeTitle={'views'}/>

                <ChartBlock
                    skipDivider={true}
                    seriesLabels={['Your engagements', 'Essentials']}
                    tooltipText={"Number of broker engagements, which include video/screenshot views, messages sent, comparison document created or collateral downloaded."}
                    title={"Engagements"} subTitle={"Brokers that engaged with your content the most"}
                    apiRoute={'engagements'} blockTypeTitle={'engagements'}/>

            </div>
        </div>
    );
}

export default DashboardPage;